import React from 'react';
import { motion } from 'framer-motion';
import { LEARN_PILLARS } from '../data/content';
import { Database, LineChart, LayoutDashboard, Sparkles } from 'lucide-react';

const ICONS = [Database, LineChart, LayoutDashboard, Sparkles];

export default function LearnPillars() {
  return (
    <section className="py-24 md:py-32 bg-page">
      <div className="container-x">
        <div className="max-w-3xl">
          <div className="section-label">{LEARN_PILLARS.eyebrow}</div>
          <h2 className="font-display text-[42px] md:text-[56px] leading-[1.02] mt-5">
            {LEARN_PILLARS.title}
            <span className="grad-text-red">{LEARN_PILLARS.titleAccent}</span>
          </h2>
          <p className="mt-6 text-[17px] text-[color:var(--muted)] leading-relaxed">{LEARN_PILLARS.intro}</p>
        </div>

        <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {LEARN_PILLARS.pillars.map((p, i) => {
            const Icon = ICONS[i];
            return (
              <motion.div
                key={p.title}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: '-80px' }}
                transition={{ duration: 0.6, delay: i * 0.08 }}
                className="card-lift bg-white border border-line rounded-2xl p-7"
              >
                <div className="w-12 h-12 rounded-xl bg-red-soft flex items-center justify-center">
                  <Icon size={22} className="text-red" />
                </div>
                <div className="mt-5 font-display text-[22px]">{p.title}</div>
                <p className="mt-3 text-[14.5px] text-[color:var(--muted)] leading-relaxed">{p.body}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
